<div appFocusNearest *isLoading="isSachverhaltLoading$ | async">
  <app-dynamic-sachverhalte-form
    [header]="header"
    [fields]="fields"
    [values]="values"
    [emptyFields]="emptyFields"
    [serverValidationErrors]="serverValidationErrors$ | async"
  >
  </app-dynamic-sachverhalte-form>

  <div class="window-button-group">
    <button
      class="btn btn-primary"
      [disabled]="!isFormValid"
      (click)="neuenSachverhaltErstellenUndWeitereAnlegen()"
      id="btn_create-and-reopen"
      *ngIf="!isBatchMode"
    >
      {{ 'action.createAndReopen' | translate }}
    </button>
    <div style="padding-right: 8px" *ngIf="isBatchMode">
      <textarea
        placeholder="{{ 'dialog.submitMessagePlaceholder' | translate }}"
        class="form-control"
        style="display: block; width: 100%; margin-bottom: 15px"
        [(ngModel)]="message"
      ></textarea>
    </div>
    <button
      class="btn btn-default"
      [disabled]="!isFormValid"
      (click)="neuenSachverhaltErstellenUndSchliessen()"
      id="btn_create-and-close"
    >
      {{ 'action.createAndClose' | translate }}
    </button>

    <button class="btn btn-default" (click)="close()" id="btn_cancel">
      {{ 'action.cancel' | translate }}
    </button>
  </div>
</div>
